export interface Entitlement {
  id: string;
  productCode: string;
  subscriptionId: string;
  userId: string;
}

export async function fetchEntitlements(userId?: string) {
  if (!userId) {
    return [];
  }
  const response = await fetch(
    `/api/fulfillment/v2/entitlements/users/${userId}`
  );
  if (!response.ok) {
    return [];
  }
  return (await response.json()) as Entitlement[];
}
